<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g>
   <path class="fil0" d="M35.27 128.08l0 557.05 3527.78 0 0 -557.05 -3527.78 0zm3342.1 928.41l-3156.49 0c-102.45,-0.07 -185.61,83.09 -185.61,185.62l0 1114.1c0,102.45 83.16,185.61 185.68,185.61l3156.42 0c102.52,0 185.68,-83.16 185.68,-185.68l0 -1114.03c0,-102.53 -83.16,-185.69 -185.68,-185.69l0 0.07zm-3342.1 2413.75l3527.78 0 0 -557.05 -3527.78 0 0 557.05z"/>
  </g>
 </g>
</svg>
